import React from 'react';

const SvgFilter = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.143555 10.8073V12.3311H4.71498V10.8073H0.143555ZM0.143555 1.66443V3.18824H7.7626V1.66443H0.143555ZM7.7626 13.8549V12.3311H13.8578V10.8073H7.7626V9.28348H6.23879V13.8549H7.7626ZM3.19117 4.71205V6.23586H0.143555V7.75967H3.19117V9.28348H4.71498V4.71205H3.19117ZM13.8578 7.75967V6.23586H6.23879V7.75967H13.8578ZM9.28641 4.71205H10.8102V3.18824H13.8578V1.66443H10.8102V0.140625H9.28641V4.71205Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgFilter;
